import type { CourseModuleMetadata } from "./types";

export function getCourseSectionLabel(
  section: Pick<CourseModuleMetadata, "kind" | "title">,
) {
  return section.kind === "appendix"
    ? `Appendix · ${section.title}`
    : section.title;
}

export function getShortCommit(commit: string) {
  return commit.slice(0, 7);
}
